<template>
  <div class="show-page">
    <div class="overlay"></div>
    <Header />
    
    <main class="main-content">
      <div class="container">
        <nav class="breadcrumb">
          <router-link to="/"><i class="fas fa-home"></i> 首页</router-link>
          <i class="fas fa-angle-right"></i>
          <router-link to="/list">企业动态</router-link>
          <i class="fas fa-angle-right"></i>
          <span>新闻详情</span>
        </nav>

        <article class="news-detail">
          <header class="news-header">
            <h1 class="news-title">{{ newsDetail.title }}</h1>
            <div class="news-meta">
              <span><i class="far fa-calendar-alt"></i> {{ newsDetail.date }}</span>
              <span><i class="far fa-eye"></i> {{ newsDetail.views }}次浏览</span>
              <span><i class="far fa-user"></i> {{ newsDetail.author }}</span>
            </div>
          </header>

          <div class="news-content">
            <p>智能仓储库存系统的预测与补货决策支持是通过整合先进的数据分析技术、机器学习算法以及实时数据监控，来优化库存水平，确保供应链的高效运作以下是一些关键技术及其应用方式：</p>
            
            <div align="center">
              <img src="@/assets/images/kcglkc.jpg" alt="系统界面展示">
            </div>
            
            <h2>1. 数据分析与预测模型</h2>
            
            <p>历史数据分析：利用过去几年的销售数据和库存记录进行分析，识别季节性趋势、周期性和其他影响因素。
            需求预测：采用时间序列分析、回归分析等统计方法或更高级的机器学习算法（如随机森林、神经网络等）来预测未来的需求。这些预测可以帮助企业更好地理解市场动态，提前做好准备。</p>
            
            <h2>2. 实时库存监控与自动化补货</h2>
            
            <p>实时监控系统：通过物联网(IoT)设备和传感器实现对库存状态的实时跟踪，及时了解库存水平的变化情况。
            自动补货建议：基于设定的安全库存水平和再订购点，系统可以自动生成补货建议，甚至直接触发采购订单，减少人为干预并提高响应速度。</p>
            
            <h2>3. 智能化决策支持</h2>
            
            <p>多级库存管理：对于具有多个仓库的企业，智能系统能够根据各个地点的具体需求和供应情况，优化每个位置的库存分配。
            情景规划与模拟：使用仿真工具测试不同的补货策略在不同市场需求情景下的表现，帮助企业做出更加明智的决策。
            成本效益分析：考虑持有成本、缺货成本等因素，帮助企业在维持服务水平的同时最小化总体库存成本。</p>
            
            <h2>4. 集成供应链协作</h2>
            
            <p>供应商协同：通过共享预测信息和库存状态，增强与供应商的合作关系，共同制定补货计划，提高整个供应链的透明度和灵活性。
            客户沟通改进：提供准确的交货时间和库存状态查询服务，提升客户满意度。</p>
            
            <h2>5. 技术创新</h2>
            
            <p>人工智能(AI)与机器学习(ML)：AI和ML技术的应用使得预测模型能够自我学习和调整，随着更多数据的积累不断提高准确性。
            大数据处理能力：强大的计算资源支持快速处理大量复杂数据集，为决策提供坚实的数据基础。
            智能仓储库存系统不仅提高了库存管理的精确度和效率，还增强了供应链的敏捷性和抗风险能力。这有助于企业在满足客户需求的同时降低库存成本，保持竞争力</p>
          </div>

          <div class="news-tags">
            <i class="fas fa-tags"></i>
            <div class="tag-list">
              <a href="#" class="tag" v-for="(tag, index) in newsDetail.tags" :key="index">{{ tag }}</a>
            </div>
          </div>

          <nav class="news-navigation">
            <div class="news-prev" v-if="newsDetail.prev">
              <router-link :to="`/show?id=${newsDetail.prev.id}`" class="news-link">
                <i class="fas fa-arrow-left"></i>
                <div class="news-text">
                  <small>上一篇</small>
                  <span class="title">{{ newsDetail.prev.title }}</span>
                </div>
              </router-link>
            </div>
            <div class="news-next" v-if="newsDetail.next">
              <router-link :to="`/show?id=${newsDetail.next.id}`" class="news-link">
                <div class="news-text">
                  <small>下一篇</small>
                  <span class="title">{{ newsDetail.next.title }}</span>
                </div>
                <i class="fas fa-arrow-right"></i>
              </router-link>
            </div>
          </nav>
        </article>
      </div>
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';

export default {
  name: 'Show',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      newsDetail: {
        id: 1,
        title: '智能仓储库存系统的预测与补货决策支持',
        date: '2024-01-18',
        views: 1280,
        author: '腾智科技',
        content: `
          <p>智能仓储库存系统的预测与补货决策支持是通过整合先进的数据分析技术、机器学习算法以及实时数据监控，来优化库存水平，确保供应链的高效运作以下是一些关键技术及其应用方式：</p>
          
          <div align="center"><img src="@/assets/images/kcglkc.jpg" alt="系统界面展示" style="max-width: 100%; height: auto;"></div>
          
          <h2>1. 数据分析与预测模型</h2>
          
          <p>历史数据分析：利用过去几年的销售数据和库存记录进行分析，识别季节性趋势、周期性和其他影响因素。
          需求预测：采用时间序列分析、回归分析等统计方法或更高级的机器学习算法（如随机森林、神经网络等）来预测未来的需求。这些预测可以帮助企业更好地理解市场动态，提前做好准备。</p>
          
          <h2>2. 实时库存监控与自动化补货</h2>
          
          <p>实时监控系统：通过物联网(IoT)设备和传感器实现对库存状态的实时跟踪，及时了解库存水平的变化情况。
          自动补货建议：基于设定的安全库存水平和再订购点，系统可以自动生成补货建议，甚至直接触发采购订单，减少人为干预并提高响应速度。</p>
          
          <h2>3. 智能化决策支持</h2>
          
          <p>多级库存管理：对于具有多个仓库的企业，智能系统能够根据各个地点的具体需求和供应情况，优化每个位置的库存分配。
          情景规划与模拟：使用仿真工具测试不同的补货策略在不同市场需求情景下的表现，帮助企业做出更加明智的决策。
          成本效益分析：考虑持有成本、缺货成本等因素，帮助企业在维持服务水平的同时最小化总体库存成本。</p>
          
          <h2>4. 集成供应链协作</h2>
          
          <p>供应商协同：通过共享预测信息和库存状态，增强与供应商的合作关系，共同制定补货计划，提高整个供应链的透明度和灵活性。
          客户沟通改进：提供准确的交货时间和库存状态查询服务，提升客户满意度。</p>
          
          <h2>5. 技术创新</h2>
          
          <p>人工智能(AI)与机器学习(ML)：AI和ML技术的应用使得预测模型能够自我学习和调整，随着更多数据的积累不断提高准确性。
          大数据处理能力：强大的计算资源支持快速处理大量复杂数据集，为决策提供坚实的数据基础。
          智能仓储库存系统不仅提高了库存管理的精确度和效率，还增强了供应链的敏捷性和抗风险能力。这有助于企业在满足客户需求的同时降低库存成本，保持竞争力</p>
        `,
        tags: ['ERP系统', '数字化转型', '企业管理', '系统升级'],
        prev: {
          id: 2,
          title: '腾智科技荣获2023年度优秀软件企业称号'
        },
        next: {
          id: 3,
          title: '腾智ERP助力某制造企业提升生产效率案例分析'
        }
      }
    }
  },
  mounted() {
    // 获取新闻ID并加载相应的新闻详情
    const newsId = this.$route.query.id;
    if (newsId) {
      // 这里应该根据ID从API获取新闻详情
      this.fetchNewsDetail(newsId);
    }
    
    // 初始化AOS动画库
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 1000,
        once: true
      });
    }
  },
  methods: {
    fetchNewsDetail(id) {
      // 这里应该实现API调用来获取新闻详情
      // 例如：axios.get(`/api/news/${id}`).then(response => this.newsDetail = response.data);
      console.log('Fetching news detail for ID:', id);
      // 在实际应用中，这里会有真实的API调用
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #009b7b;
  --secondary-color: #006d56;
  --text-color: #2c3e50;
  --white: #ffffff;
}

.breadcrumb {
  display: flex;
  align-items: center;
  padding: 1rem 0;
  margin-bottom: 2rem;
  font-size: 0.9rem;
  color: #666;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.breadcrumb a:hover {
  color: var(--primary-color);
}

.breadcrumb i {
  margin: 0 0.5rem;
  font-size: 0.8rem;
}

.breadcrumb span {
  color: #333;
  font-weight: 500;
}

/* 新闻详情 */
.news-detail {
  background: white;
  border-radius: 8px;
  padding: 2.5rem;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 3rem;
}

.news-header {
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1.5rem;
  text-align: center;
}

.news-title {
  font-size: 2.2rem;
  color: var(--primary-color);
  line-height: 1.3;
  margin-bottom: 1rem;
}

.news-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  color: #888;
  font-size: 0.95rem;
}

.news-meta span {
  display: flex;
  align-items: center;
}

.news-meta i {
  margin-right: 0.5rem;
}

/* 新闻内容 */
.news-content {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
}

.news-content p {
  margin-bottom: 1.5rem;
}

.news-content h2 {
  font-size: 1.6rem;
  margin: 2.5rem 0 1.5rem;
  color: var(--primary-color);
  border-left: 4px solid var(--primary-color);
  padding-left: 1rem;
}

.news-content img {
  max-width: 100%;
  border-radius: 8px;
  margin: 1.5rem 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.news-content div[align="center"] {
  margin: 2rem 0;
}

/* 标签 */
.news-tags {
  display: flex;
  align-items: center;
  margin: 2.5rem 0;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.news-tags i {
  color: #666;
  margin-right: 1rem;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag {
  background: rgba(0, 155, 123, 0.1);
  color: var(--primary-color);
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  text-decoration: none;
  transition: all 0.3s;
}

.tag:hover {
  background: var(--primary-color);
  color: white;
}

/* 上一篇/下一篇导航 */
.news-navigation {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-top: 2.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.news-prev, .news-next {
  position: relative;
}

.news-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  transition: all 0.3s;
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
}

.news-link:hover {
  background: rgba(0, 155, 123, 0.1);
}

.news-prev .news-link {
  padding-left: 2rem;
}

.news-next .news-link {
  padding-right: 2rem;
  justify-content: flex-end;
}

.news-text {
  display: flex;
  flex-direction: column;
}

.news-text small {
  color: #666;
  margin-bottom: 0.3rem;
}

.news-text .title {
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-prev i {
  margin-right: 1rem;
  font-size: 1.2rem;
}

.news-next i {
  margin-left: 1rem;
  font-size: 1.2rem;
}

@media (max-width: 768px) {
  .news-detail {
    padding: 1.5rem;
  }

  .news-title {
    font-size: 1.8rem;
  }

  .news-content {
    font-size: 1rem;
  }

  .news-navigation {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .news-meta {
    gap: 1rem;
  }
}
</style>